<template>
  <div>
    <template>
      <CommonPannel
        :leftData="leftData"
        :columns="selectPanelColumns"
        :rightData="value"
        @selectValues="handleValues"
        :selectPlaceholder="selectPlaceholder"
        :disabled="disabled"
        :reverse="reverse"
      >
        <slot name="extraBtn" slot="extra"></slot>
      </CommonPannel>
    </template>
  </div>
</template>
<script>
import CommonPannel from '@/components/common/CommonPannel'
export default {
  components: {
    CommonPannel
  },
  props: ['leftData', 'selectPlaceholder', 'selectPanelColumns', 'value', 'disabled', 'reverse'],
  data() {
    return {}
  },
  methods: {
    handleValues(data) {
      this.$emit('input', data)
    }
  }
}
</script>
<style lang="stylus" scoped>
>>>.el-form-item
  margin 10px 0
</style>
